!(function () {
  "use strict"
  customElements.get("zoom-images") ||
    customElements.define(
      "zoom-images",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.mediaContainer = this.closest(
              "[data-product-single-media-group]"
            )),
            (this.slider = this.mediaContainer?.querySelector(
              "[data-product-single-media-slider]"
            )),
            (this.a11y = window.theme.a11y)
        }
        connectedCallback() {
          this.productZoomReinit()
        }
        productZoomReinit() {
          ;(this.zoomWrappers = this.mediaContainer?.querySelectorAll(
            "[data-zoom-wrapper]"
          )),
            this.zoomWrappers &&
              this.zoomWrappers.length &&
              this.zoomWrappers.forEach((e, t) => {
                e.removeEventListener("click", e._z),
                  (e._z = (o) => {
                    o.preventDefault(),
                      (this.slider &&
                        this.slider.classList.contains("is-moving")) ||
                        ((this.a11y.state.trigger = e), this.createZoom(t))
                  }),
                  e.addEventListener("click", e._z)
              })
        }
        createZoom(e) {
          let o = [],
            s = 0
          const i = this.mediaContainer?.querySelectorAll("[data-zoom-wrapper]")
          i.forEach((a) => {
            const r = a.getAttribute("href"),
              l = parseInt(a.getAttribute("data-image-width")),
              n = parseInt(a.getAttribute("data-image-height"))
            o.push({ src: r, w: l, h: n, msrc: r }),
              (s += 1),
              i.length === s &&
                (function () {
                  let s = "pswp-zoom-gallery"
                  1 === i.length &&
                    (s = "pswp-zoom-gallery pswp-zoom-gallery--single")
                  const a = {
                    barsSize: { top: 60, bottom: 60 },
                    history: !1,
                    focus: !1,
                    index: e,
                    mainClass: s,
                    showHideOpacity: !0,
                    showAnimationDuration: 250,
                    hideAnimationDuration: 250,
                    closeOnScroll: !1,
                    closeOnVerticalDrag: !1,
                    captionEl: !1,
                    closeEl: !0,
                    closeElClasses: ["caption-close"],
                    tapToClose: !1,
                    clickToCloseNonZoomable: !1,
                    maxSpreadZoom: 2,
                    loop: !0,
                    spacing: 0,
                    allowPanToNext: !0,
                    pinchToClose: !1,
                  }
                  new window.theme.LoadPhotoswipe(o, a)
                })()
          })
        }
      }
    )
})()
